import { render, staticRenderFns } from "./miniprogSettings.vue?vue&type=template&id=b14cf742&scoped=true&"
import script from "./miniprogSettings.vue?vue&type=script&lang=js&"
export * from "./miniprogSettings.vue?vue&type=script&lang=js&"
import style0 from "./miniprogSettings.vue?vue&type=style&index=0&id=b14cf742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14cf742",
  null
  
)

export default component.exports